import React from "react";
import "./LeftMiddleDashBoard.css";
import { useState, useCallback, useEffect } from "react";
import {
  csv,
  extent,
  scaleLinear,
  scaleTime,
  max,
  format,
  timeFormat,
  curve,
  curveBasis,
  line,
  scaleBand,
  area,
  curveCardinal,
  curveCardinalClosed,
  curveCardinalOpen,
  curveLinear,
  curveNatural,
} from "d3";
import BarIcon from "../Icons/BarIcon";

const csvUrl =
  "https://gist.githubusercontent.com/VasumathiArichandran/d4647a1510edde39d3529353e831a60b/raw/59cdfa78c71725fdbcb7cfb7fd7feb4ba59b3d78/ScatterPlot.csv";
const width = 160;
const height = 380;
const margin = { top: 10, right: 10, bottom: 20, left: 20 };
export default function LeftMiddleDashBoard() {
  var [data, setData] = useState(null);
  useEffect(() => {
    var row = (d) => {
      d.Population = +d["2050"];
      d.Population1 = +d["2025"];

      return d;
    };
    csv(csvUrl, row).then(setData);
  }, []);

  if (!data) {
    return <pre>Loading...</pre>;
  }
  const innerHeight = height - margin.top - margin.bottom;
  const innerWidth = width - margin.left - margin.right;

  console.log(data[1]);

  // const yScale = scaleLinear()
  //.domain([0, max(data, (d) => d.Month)])

  // .domain(extent(data, (d) => d.Month))
  // .range([0, innerHeight]);

  const yScale = scaleBand()
    .domain(data.map((d) => d.Month))
    .range([-60, height+60]);

  const xScale = scaleLinear()
    .domain([0, max(data, (d) => d.Population)])
    // .domain(extent(data, (d) => d.Population))
    .range([0, innerWidth]);

  //console.log(yScale.ticks());
  const Month = timeFormat("%b");
  console.log(Month(1));
  return (
    <>
      <div className="LeftMiddleDashBoard">
        <div className="LeftMiddleDashBoardHeading">
          <p className="Perfomace1">Peformace</p>
          <p className="Perfomace2">Performa sangat mantap</p>
        </div>

        <svg className="curveChart" width={width} height={height}>
          <g
            width={width}
            height={height}
            transform={`translate(${margin.left},${margin.top})`}
          >
            {xScale.ticks().map((tickValue) => (
              <g
                width={width}
                height={height}
                key={tickValue}
                transform={`translate(${xScale(tickValue)},0)`}
              >
                {/* <line y2={innerHeight} stroke="#c0c0bb" /> */}
                {/* <text
                  className="xScaleText"
                  style={{ textAnchor: "middle", fontSize: "10px" }}
                  dy="-37.2em"
                  y={innerHeight}
                > */}
                  {/* {tickFormat(tickValue)} */}
                  {/* {format(".2s")(tickValue).replace("G", "B")} */}
                  {/* {tickValue} */}
                  {/* {Intl.DateTimeFormat("en", { month: "long" }).format(
                    new Date(tickValue)
                  )
                  } */}
                {/* </text> */}
              </g>
            ))}
            {yScale.domain().map((tickValue) => (
              <g
                width={width}
                height={height}
                transform={`translate(0,${yScale(tickValue)})`}
              >
                <line x2={innerWidth} stroke="#e1e3e2" />
                <text
                  key={tickValue}
                  className="xScaleTextCurve"
                  dx="-8.31em"
                  x={innerWidth-2}
                  y={16}
                >
                  {Intl.DateTimeFormat("en", { month: "short" }).format(
                    new Date(5, tickValue-1, 5)
                  )}
                </text>
              </g>
            ))}
            {/* <text
              x={innerWidth / 2}
              y={innerHeight}
              style={{ textAnchor: "middle", fontSize: "10px" }}
            ></text> */}
            <path
              fill="rgba(232, 237, 234,0.7)"
              stroke="black"
              width={width}
              height={height}
              d={line()
                .x((d) => xScale(d.Population))
                .y((d) => yScale(d.Month))
                .curve(curveCardinal)(data)}
            />
            <path
              fill="rgba(232, 237, 234,0)"
              stroke="grey"
              width={width}
              height={height}
              d={line()
                .x((d) => xScale(d.Population1))
                .y((d) => yScale(d.Month))
                .curve(curveCardinal)(data)}
            />

            {/* <path
              fill="grey"
              stroke="grey"
              d={area()
                .x((d) => xScale(d.Population))
                .y0(height)
                .y1((d) => yScale(d.Month))(data)}
            /> */}

            {data.map((d) => (
              <>
                <circle
                  width={width}
                  height={height}
                  key={d.Population}
                  className="curve"
                  cx={xScale(d.Population)}
                  cy={yScale(d.Month)}
                  r={0}
                />
                <circle
                  key={d.Population1}
                  width={width}
                  height={height}
                  className="curve1"
                  cx={xScale(d.Population1)}
                  cy={yScale(d.Month)}
                  r={0}
                />
              </>
            ))}
            <circle className="curve1" cx={80} cy={366} r={3} />
          </g>
        </svg>
      </div>
    </>
  );
}
